<template>
  <div class="text-xs-center">
    <v-dialog v-model="controlDialogVisible" scrollable :fullscreen="fullscreen" max-width="80%" :persistent="!closeWithMask">
      <data-table-called-history :data-value="calledHitories" :is-dialog="true">
      </data-table-called-history>
    </v-dialog>
  </div>
</template>
<script>
import DialogMixin from '@/components/mixins/DialogMixin';
import CallHistoryService from '@/features/call-histories/CallHistoryService';
import DataTableCalledHistory from '@/features/report/DataTableCalledHistory';

export default {
  name: 'data-table-called-history-dialog',
  mixins: [DialogMixin],
  components: {
    DataTableCalledHistory,
  },
  props: {
    dataValue: {
      required: true,
    },
  },
  data() {
    return {
      calledHitories: [],
      callHistoryService: new CallHistoryService(),
    };
  },
  created() {
    this.calledHitories = this.dataValue;
  },
};
</script>



// WEBPACK FOOTER //
// src/features/report/DataTableDialog.vue